import { render } from "./DynamicToolBar.vue?vue&type=template&id=95b2b018&ts=true"
import script from "./DynamicToolBar.vue?vue&type=script&lang=ts"
export * from "./DynamicToolBar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicToolBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "95b2b018"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('95b2b018', __exports__)) {
    api.reload('95b2b018', __exports__)
  }
  
  module.hot.accept("./DynamicToolBar.vue?vue&type=template&id=95b2b018&ts=true", () => {
    api.rerender('95b2b018', render)
  })

}


export default __exports__